<template>
  <div class="texts-select-input clearfix">
    <div class="form-group row">
      <label :class="options.fullWidth ? 'col-sm-12' : 'col-sm-3 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-9'">
        <select class="form-control" ref="dropdown" multiple
        :name="options.name+'[]'" @change="validate()">
          <option 
            v-for="(val, index) in options.existing"
            :key="index"
            :value="val"
            :checked="val === value">{{ val }}</option>
        </select>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import Choices from 'choices.js'
  import dom from '@/util/dom'
  import Api from '@/vuex/api'
  import {
    validationClass,
    formControlValidationClass,
    validationMessage
  } from '@/util/helpers'

  export default {
    name: 'TextsSelectInput',
    props: {
      value: {
        type: Array
      },
      options: {
        type: Object,
        default () {
          return {
            label: 'Text',
            name: 'texts-select',
            existing: [],
            valid: false,
            value: [],
            dirty: false,
            required: false
          }
        }
      }
    },
    data () {
      return {
        isDirty: false,
        isValid: false,
        existingValues: [],
        choices: false
      }
    },
    computed: {
      label () {
        return this.options.singleLabel
          ? this.options.singleLabel
          : this.options.label
      },
      validationClass,
      formControlValidationClass,
      validationMessage,
      invalidMessage () {
        if (this.options.required) {
          return this.options.label + ' is required'
        } else {
          return 'Invalid value'
        }
      }
    },
    mounted () {
      this.existingValues = this.options.existing || []
      /* eslint-disable no-new */
      let $vm = this
      this.choices = new Choices(this.$refs.dropdown, {
        placeholderValue: 'Enter a ' + this.options.label,
        noResultsText: 'Press enter to add a new value',
        itemSelectText: '',
        removeItemButton: true,
        fuseOptions: {
          threshold: 0
        },
        callbackOnInit: function () {
          this.containerInner.id = $vm.options.name
          if ($vm.value) {
            this.setValueByChoice($vm.value)
            $vm.validate()
          }
        }
      })
      // add custom adding items behaviour
      this.$refs.dropdown.addEventListener('search', (event) => {
        this.currentResults = !this.choices.choiceList.innerHTML.includes('Press enter to add a new value')
        this.choices.input.addEventListener('keydown', this.addSearchValue)
      })
      // fix bug that causes dropdown to continually close until a key event is detected
      this.$refs.dropdown.addEventListener('showDropdown', (event) => {
        this.choices.clearInput()
        this.$nextTick(function () {
          var e = new window.Event('keydown', {
            'bubbles': true
          })
          e.key = 'a'
          e.keyCode = e.key.charCodeAt(0)
          e.which = e.keyCode
          e.altKey = false
          e.ctrlKey = true
          e.shiftKey = false
          e.metaKey = false
          this.choices.input.dispatchEvent(e)
          this.choices.input.focus()
        })
      })
      this.validate()
    },
    methods: {
      async validate () {
        await this.$nextTick()
        let val = this.choices.getValue(true)
        this.$emit('input', val)
        if (val.length > 0) {
          this.isDirty = true
          if (this.options.required) {
            this.isValid = val ? val.length > 0 : true
          } else {
            this.isValid = true
          }
        } else if (this.options.required) {
          this.isDirty = true
          this.isValid = false
        } else {
          this.isValid = true
        }
        let choicesInner = document.getElementById(this.options.name)
        if (this.isValid) {
          if (dom(choicesInner).hasClass('is-invalid')) {
            dom(choicesInner).removeClass('is-invalid')
          }
          if (!dom(choicesInner).hasClass('is-valid')) {
            dom(choicesInner).addClass('is-valid')
          }
        } else {
          if (dom(choicesInner).hasClass('is-valid')) {
            dom(choicesInner).removeClass('is-valid')
          }
          if (!dom(choicesInner).hasClass('is-invalid')) {
            dom(choicesInner).addClass('is-invalid')
          }
        }
      },
      async addSearchValue (e) {
        // check if enter key is pressed, then add value
        let key = e.which || e.keyCode
        if (key === 13 && !this.currentResults) {
          this.validate(this.choices.currentValue)
          this.choices.setValue([this.choices.currentValue])
          await this.$nextTick()
          this.choices.input.value = ''
          this.validate()
        }
      },
      runWatcher (val, name) {
        switch (name) {
          case 'companyName':
            this.getManagers(val)
            break
        }
      },
      resetChoices (options = this.existingValues) {
        this.$emit('input', [])
        if (this.choices) {
          this.choices.clearInput()
          this.choices.removeHighlightedItems()
          this.choices.removeActiveItems()
          if (this.choices.containerInner.children[1].children[0]) {
            this.choices.containerInner.children[1].children[0].innerHTML = ''
          }
          this.choices.setChoices(options, 'value', 'label', true)
        }
      },
      async getManagers (val) {
        let instance = new Api()
        let company = await instance.getCompany(val)
        if (company && company.Accounts.length) {
          company.Accounts.map(function (val, i) {
            company.Accounts[i] = { value: val.email, label: val.dropdownLabel }
          })
          this.resetChoices(company.Accounts)
        } else {
          this.resetChoices()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/inputs/TextsSelectInput.vue